"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createBreadcrumb = createBreadcrumb;

var locationHelper = _interopRequireWildcard(require("./CasaOldLocationHelper"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
 * CasaOldBreadcrumbHelper:
 * USED ONLY FOR OLD SEO URL -- Will be deprecated with the full passage to the new url
 */
var startsWithAlt = function startsWithAlt(str, match) {
  return str && str.indexOf(match) === 0;
};

function createBreadcrumb(data) {
  var channel = data.tr;
  var category = data.category;
  var agencyId = data.publisherId;
  var breadcrumb = [];
  var SEOlabel;

  if (channel === 'vendita') {
    switch (category) {
      case 'commerciale':
        SEOlabel = 'Immobili commerciali in vendita';
        break;

      case 'vacanze':
        SEOlabel = 'Case vacanze in vendita';
        break;

      default:
        SEOlabel = 'Immobili e case in vendita';
    }
  } else {
    switch (category) {
      case 'commerciale':
        SEOlabel = 'Immobili commerciali in affitto';
        break;

      case 'vacanze':
        SEOlabel = 'Case vacanze in affitto';
        break;

      default:
        SEOlabel = 'Appartamenti in affitto';
    }
  }

  try {
    if ('locations' in data) {
      data.locations.map(function (item) {
        if (item.type === 'street') {
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : item.levels.L4,
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : "".concat(SEOlabel, " in ").concat(item.levels.L4),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.STATE,
            isLabel: false
          });
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT) : "".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT),
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT) : "".concat(SEOlabel, " in provincia di ").concat(item.levels.L6),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.PROVINCE,
            isLabel: false
          });
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L9, " (").concat(item.levels.L6, ")") : "".concat(item.levels.L9, " (").concat(item.levels.L6, ")"),
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L9, " (").concat(item.levels.L6, ")") : "".concat(SEOlabel, " a ").concat(item.levels.L9),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L9.toLowerCase(), "%2c+").concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L9.toLowerCase(), "%2c+").concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.CITY,
            isLabel: false
          });
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L10, ", ").concat(item.levels.L9) : "".concat(item.levels.L10, ", ").concat(item.levels.L9),
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L10, ", ").concat(item.levels.L9) : "".concat(SEOlabel, " a ").concat(item.levels.L10, ", ").concat(item.levels.L9),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L10.toLowerCase(), "%2c+").concat(item.levels.L9.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L10.toLowerCase(), "%2c+").concat(item.levels.L9.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.STREET,
            isLabel: true
          });
        } else if (startsWithAlt(item.type, 'CITY_SECTION')) {
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : item.levels.L4,
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : "".concat(SEOlabel, " in ").concat(item.levels.L4),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.STATE,
            isLabel: false
          });
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT) : "".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT),
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT) : "".concat(SEOlabel, " in provincia di ").concat(item.levels.L6),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.PROVINCE,
            isLabel: false
          });
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L9, " (").concat(item.levels.L6, ")") : "".concat(item.levels.L9, " (").concat(item.levels.L6, ")"),
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L9, " (").concat(item.levels.L6, ")") : "".concat(SEOlabel, " a ").concat(item.levels.L9),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L9.toLowerCase(), "%2c+").concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L9.toLowerCase(), "%2c+").concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.CITY,
            isLabel: false
          });
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : item.levels.L10,
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : "".concat(SEOlabel, " in zona ").concat(item.levels.L10),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L10.toLowerCase().replace(/ /g, '+').replace(/\//g, '%2f'), "%2C+").concat(item.levels.L9.toLowerCase(), "%2c+").concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L10.toLowerCase().replace(/ /g, '+').replace(/\//g, '%2f'), "%2c+").concat(item.levels.L9.toLowerCase(), "%2c+").concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.ZONE,
            isLabel: true
          });
        } else if (item.type === 'province' || item.type === 'province') {
          // PROVINCIA
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : item.levels.L4,
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : "".concat(SEOlabel, " in ").concat(item.levels.L4),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.STATE,
            isLabel: false
          });
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT) : "".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT),
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT) : "".concat(SEOlabel, " in provincia di ").concat(item.levels.L6),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L6.toLowerCase(), "%2C+").concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L6.toLowerCase(), "%2C+").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.PROVINCE,
            isLabel: true
          });
        } else if (item.type === 'region') {
          // REGIONE
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : item.levels.L4,
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : "".concat(SEOlabel, " in ").concat(item.levels.L4),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.STATE,
            isLabel: true
          });
        } else if (item.type === 'freetext') {
          // FREE TEXT
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.name) : item.name,
            title: agencyId ? "Agenzie immobiliari ".concat(item.name) : "".concat(SEOlabel, ": ").concat(item.name),
            href: agencyId ? "/agenzie/in-".concat(item.name, "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.name, "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.FREE_TEXT,
            isLabel: true
          });
        } else if (item.type === 'region') {
          // REGIONE GEOGRAFICA
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : item.levels.L4,
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : "".concat(SEOlabel, " in ").concat(item.levels.L4),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.STATE,
            isLabel: false
          });
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : item.levels.L4,
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : "".concat(SEOlabel, " in ").concat(item.levels.L4),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.REGION,
            isLabel: true
          });
        } else if (item.type === 'postalcode') {
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : item.levels.L4,
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : "".concat(SEOlabel, " in ").concat(item.levels.L4),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.STATE,
            isLabel: false
          });
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT) : "".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT),
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT) : "".concat(SEOlabel, " in provincia di ").concat(item.levels.L6),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.PROVINCE,
            isLabel: false
          });
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L9, " (").concat(item.levels.L6, ")") : "".concat(item.levels.L9, " (").concat(item.levels.L6, ")"),
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L9, " (").concat(item.levels.L6, ")") : "".concat(SEOlabel, " a ").concat(item.levels.L9),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L9.toLowerCase(), "%2c+").concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L9.toLowerCase(), "%2c+").concat(item.levels.L6.toLowerCase(), "%2c+").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.CITY,
            isLabel: false
          });
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.postalcode, ", ").concat(item.levels.L9) : "".concat(item.postalcode, ", ").concat(item.levels.L9),
            title: agencyId ? "Agenzie immobiliari ".concat(item.postalcode, ", ").concat(item.levels.L9) : "".concat(SEOlabel, " a ").concat(item.postalcode, ", ").concat(item.levels.L9),
            href: agencyId ? "/agenzie/in-".concat(item.postalcode, "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.postalcode, "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.POSTAL_CODE,
            isLabel: true
          });
        } else {
          breadcrumb.push({
            label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : item.levels.L4,
            title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L4) : "".concat(SEOlabel, " in ").concat(item.levels.L4),
            href: agencyId ? "/agenzie/in-".concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L4.toLowerCase(), "/lista-1"),
            type: locationHelper.CATEGORY_TYPE.STATE,
            isLabel: false
          });

          if (!locationHelper.isFranceProvince(item.levels.L6)) {
            breadcrumb.push({
              label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT) : "".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT),
              title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L6, " ").concat(locationHelper.PROVINCE_IT) : "".concat(SEOlabel, " in provincia di ").concat(item.levels.L6),
              href: agencyId ? "/agenzie/in-".concat(item.levels.L6.toLowerCase(), "%2C+").concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L6.toLowerCase(), "%2C+").concat(item.levels.L4.toLowerCase(), "/lista-1"),
              type: locationHelper.CATEGORY_TYPE.PROVINCE,
              isLabel: false
            });
            breadcrumb.push({
              label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L9, " (").concat(item.levels.L6, ")") : "".concat(item.levels.L9, " (").concat(item.levels.L6, ")"),
              title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L9, " (").concat(item.levels.L6, ")") : "".concat(SEOlabel, " a ").concat(item.levels.L9),
              href: agencyId ? "/agenzie/in-".concat(item.levels.L9.toLowerCase(), "%2C+").concat(item.levels.L6.toLowerCase(), "%2C+").concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L9.toLowerCase(), "%2C+").concat(item.levels.L6.toLowerCase(), "%2C+").concat(item.levels.L4.toLowerCase(), "/lista-1"),
              type: locationHelper.CATEGORY_TYPE.CITY,
              isLabel: true
            });
          } else {
            breadcrumb.push({
              label: agencyId ? "Agenzie immobiliari ".concat(item.levels.L9) : item.levels.L9,
              title: agencyId ? "Agenzie immobiliari ".concat(item.levels.L9) : "".concat(SEOlabel, " a ").concat(item.levels.L9),
              href: agencyId ? "/agenzie/in-".concat(item.levels.L9.toLowerCase(), "%2C+").concat(item.levels.L4.toLowerCase(), "/lista-1") : "/".concat(channel, "-").concat(category, "/in-").concat(item.levels.L9.toLowerCase(), "%2C+").concat(item.levels.L4.toLowerCase(), "/lista-1"),
              type: locationHelper.CATEGORY_TYPE.CITY,
              isLabel: true
            });
          }
        }

        return item;
      });

      var allEqualValue = function allEqualValue(arr) {
        for (var i = 1; i < arr.length; i++) {
          if (arr[i].label !== arr[0].label) return false;
        }

        return true;
      };

      var checkType = function checkType(arrValues, arrResult) {
        if (arrValues.length > 1 && !allEqualValue(arrValues)) {
          return arrResult;
        } else if (arrValues.length) {
          arrResult.push(arrValues[0]);
        }

        return arrResult;
      };

      var finalBreadcrumb = [];
      var states = breadcrumb.filter(function (item) {
        return item.type === locationHelper.CATEGORY_TYPE.STATE;
      });
      checkType(states, finalBreadcrumb);
      var provinces = breadcrumb.filter(function (item) {
        return item.type === locationHelper.CATEGORY_TYPE.PROVINCE;
      });
      checkType(provinces, finalBreadcrumb);
      var cities = breadcrumb.filter(function (item) {
        return item.type === locationHelper.CATEGORY_TYPE.CITY;
      });
      checkType(cities, finalBreadcrumb);
      var zones = breadcrumb.filter(function (item) {
        return item.type === locationHelper.CATEGORY_TYPE.ZONE;
      });
      checkType(zones, finalBreadcrumb);
      var streets = breadcrumb.filter(function (item) {
        return item.type === locationHelper.CATEGORY_TYPE.STREET;
      });
      checkType(streets, finalBreadcrumb);
      var regions = breadcrumb.filter(function (item) {
        return item.type === locationHelper.CATEGORY_TYPE.REGION;
      });
      checkType(regions, finalBreadcrumb);
      var postalCodes = breadcrumb.filter(function (item) {
        return item.type === locationHelper.CATEGORY_TYPE.POSTAL_CODE;
      });
      checkType(postalCodes, finalBreadcrumb);
      return finalBreadcrumb;
    }
  } catch (err) {
    console.error('breadcrumb generation error', err);
  }

  return breadcrumb;
}